import React, {ReactNode} from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  max-width: 570px;
  margin-left: auto;
  margin-right: auto;
  padding: ${({theme}) => `0px ${theme.spacing.four} ${theme.spacing.one}`};
`

interface Props {
  children: ReactNode
}

const Bottom: React.FC<Props> = ({children}) => {
  return <Wrapper>{children}</Wrapper>
}

export default Bottom
